import {Component, OnDestroy, OnInit} from "@angular/core";
import {ItemPreguntaDTO, PreguntaDTO} from "@DTOS";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {obtenerIdPreguntaTipo, PreguntasTipoEnum} from "@shared/enums";
import {ItemPreguntaModelDTO, PreguntaModelDTO} from "@Models";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {Subscription} from "rxjs";
import {debounceTime, filter, mergeMap, tap} from "rxjs/operators";
import {Store} from "@ngxs/store";
import {ModalService, NotificacionServiceEmisor} from "@shared/services";
import {
    EditorCondicionesComponent
} from "../../../../encuestas-detalle/editor-condiciones/editor-condiciones.component";
import {TipoPreguntaBreakpointComponent} from "../tipo-pregunta-breakpoint/tipo-pregunta-breakpoint.component";


@Component({
    selector: "app-tipo-pregunta-matriz-multiple",
    templateUrl: "./tipo-pregunta-matriz-multiple.component.html",
    styleUrls: ["./tipo-pregunta-matriz-multiple.component.scss"]
})
export class TipoPreguntaMatrizMultipleComponent extends TipoPreguntaBreakpointComponent implements OnInit, OnDestroy {
    public pregunta: PreguntaModelDTO;

    public subPreguntas: PreguntaModelDTO[] = [];
    public items: ItemPreguntaModelDTO[] = [];

    public colores = {};
    public textoPregunta = "";
    public textoItem = "";

    public agregarPreguntaCmd: ICommand = new CommandAsync(() => this.agregarSubpregunta());
    public borrarPreguntaCmd: ICommand = new CommandAsync((pregunta: PreguntaModelDTO) =>
        this.borrarSubpregunta(pregunta));
    public agregarItemCmd: ICommand = new CommandAsync(() => this.agregarItem());
    public borrarItemCmd: ICommand = new CommandAsync((item: ItemPreguntaModelDTO) =>
        this.borrarItem(item));

    private subsPreguntas = new Subscription();
    private subsItems = new Subscription();

    constructor(store: Store, private tiposPreguntasService: TiposPreguntasService, private modalService: ModalService,
        private notificacionService: NotificacionServiceEmisor) {
        super(store);
    }

    ngOnInit() {
        this.pregunta = this.tiposPreguntasService.preguntaModel;
        this.colores = this.tiposPreguntasService.colores;

        this.cargarModelsPregunta();
        this.cargarItemsPregunta();
    }

    ngOnDestroy() {
        this.subsPreguntas.unsubscribe();
        this.subsItems.unsubscribe();
    }

    public obtenerId(tipoPregunta: PreguntasTipoEnum) {
        return obtenerIdPreguntaTipo(tipoPregunta);
    }

    public clickBorrarPregunta(pregunta: PreguntaModelDTO) {
        if (this.borrarPreguntaCmd.puedeEjecutarse) {
            this.borrarPreguntaCmd.ejecutar(pregunta);
        }
    }

    public clickBorrarItem(item: ItemPreguntaModelDTO) {
        if (this.borrarItemCmd.puedeEjecutarse) {
            this.borrarItemCmd.ejecutar(item);
        }
    }

    public abrirEditorCondiciones(pregunta: PreguntaModelDTO) {
        const modalRef = this.modalService.open(
            EditorCondicionesComponent, { size: "lg", centered: true, windowClass: "modal-condiciones" }
        );
        const instancia: EditorCondicionesComponent = modalRef.componentInstance;
        instancia.encuesta = this.tiposPreguntasService.encuesta;
        instancia.pregunta = pregunta;
    }

    public abrirEditorCondicionesItem(item: ItemPreguntaModelDTO) {
        const modalRef = this.modalService.open(
            EditorCondicionesComponent, { size: "lg", centered: true, windowClass: "modal-condiciones" }
        );
        const instancia: EditorCondicionesComponent = modalRef.componentInstance;
        instancia.encuesta = this.tiposPreguntasService.encuesta;
        instancia.item = item;
    }

    private async agregarSubpregunta() {
        let subPreguntaDTO = new PreguntaDTO({
            text: this.textoPregunta,
            type: obtenerIdPreguntaTipo(PreguntasTipoEnum.MULTIPLE_CHOICE),
            next_question: this.subPreguntas[this.subPreguntas.length - 1].SiguientePregunta
        });

        this.textoPregunta = "";
        subPreguntaDTO = await this.tiposPreguntasService.agregarSubpreguntaPregunta(
            this.pregunta.Entidad, subPreguntaDTO
        );
        const model = new PreguntaModelDTO(subPreguntaDTO);
        this.subsPreguntas.add(
            model.changed$.pipe(
                filter(Boolean),
                debounceTime(200),
                mergeMap(() => this.tiposPreguntasService.guardarSubpreguntaPregunta(subPreguntaDTO)),
                tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
            ).subscribe()
        );
        this.subPreguntas.push(model);
        this.notificacionService.notificarExito("Subpregunta agregada correctamente.");
    }

    private async borrarSubpregunta(subpregunta: PreguntaModelDTO) {
        await this.tiposPreguntasService.borrarSubpreguntaPregunta(this.pregunta.Entidad, subpregunta.Entidad);
        this.subsPreguntas.unsubscribe();
        this.subsPreguntas = new Subscription();
        this.cargarModelsPregunta();
        this.notificacionService.notificarExito("Subpregunta borrada correctamente.");
    }

    private async agregarItem() {
        let itemPreguntaDTO = new ItemPreguntaDTO({
            text: this.textoItem
        });

        this.textoItem = "";
        itemPreguntaDTO = await this.tiposPreguntasService.agregarItemPregunta(this.pregunta.Entidad, itemPreguntaDTO);
        const model = new ItemPreguntaModelDTO(itemPreguntaDTO);
        this.subsPreguntas.add(
            model.changed$.pipe(
                filter(Boolean),
                debounceTime(200),
                mergeMap(() => this.tiposPreguntasService.guardarItemPregunta(this.pregunta.Entidad, itemPreguntaDTO)),
                tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
            ).subscribe()
        );
        this.items.push(model);
        this.notificacionService.notificarExito("Item agregado correctamente.");
    }
    private async borrarItem(item: ItemPreguntaModelDTO) {
        await this.tiposPreguntasService.borrarItemPregunta(this.pregunta.Entidad, item.Entidad);
        this.subsItems.unsubscribe();
        this.subsItems = new Subscription();
        this.cargarItemsPregunta();
        this.notificacionService.notificarExito("Item borrado correctamente.");
    }

    private cargarModelsPregunta() {
        this.subPreguntas = this.pregunta.Preguntas?.map(subPregunta => {
            const model = new PreguntaModelDTO(subPregunta);
            this.subsPreguntas.add(
                model.changed$.pipe(
                    filter(Boolean),
                    debounceTime(200),
                    mergeMap(() => this.tiposPreguntasService.guardarSubpreguntaPregunta(subPregunta)),
                    tap(() => this.notificacionService.notificarExito("Subpregunta modificada correctamente."))
                ).subscribe()
            );
            return model;
        }) ?? [];
    }

    private cargarItemsPregunta() {
        this.items = this.pregunta.Items.map(item => {
            const model = new ItemPreguntaModelDTO(item);
            this.subsItems.add(
                model.changed$.pipe(
                    filter(Boolean),
                    debounceTime(200),
                    mergeMap(() => this.tiposPreguntasService.guardarItemPregunta(this.pregunta.Entidad, item)),
                    tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
                ).subscribe()
            );
            return model;
        });
    }
}
